export default class OccasionMessageState {
  isSelected = Boolean;
  text = String;

  select() {
    return this.isSelected.set(true);
  }

  deselect() {
    return this.isSelected.set(false);
  }
}
